/*eslint-disable*/ export const messages = JSON.parse("{\"radio-group.label.optional\":[\"Valgfri\"],\"radio-group.validation.required\":[\"Vælg en mulighed.\"]}");
//# sourceMappingURL=messages.mjs.map